import { assetUrl } from '../api/assets';

/** Raster UI sticker (`assets/ui/ui_*.png`). Decorative — the surrounding label is the name. */
export function UiSticker({ id, className }: { id: string; className?: string }) {
  return (
    <img
      className={className ?? 'ui-sticker'}
      src={assetUrl(id)}
      alt=""
      draggable={false}
    />
  );
}
